import React from 'react';
import AppProvider from './src/providers/AppProvider';
import TextFieldGoogleAutocompleteComponent from './src/components/TextFieldGoogleAutocomplete';

export { default as Mapa } from './src/Mapa';
export { PRODUCTS as produtos } from './src/config/constants';
export { default as MapaContext } from './src/context/Mapa';

export function TextFieldGoogleAutocomplete(props) {
  return (
    <AppProvider>
      <TextFieldGoogleAutocompleteComponent {...props} />
    </AppProvider>
  );
}
